import React, { useState } from "react";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Avatar from "@mui/material/Avatar";
import Stack from "@mui/material/Stack";
import FileUpload from "@mui/icons-material/FileUpload";
import { addImageAndGetUrl } from "./apiHelpers";
import { uploadJPG } from "./fileUploadHelper";
import CircularProgress from "@mui/material/CircularProgress";

type ProfileProps = {
  name?: string;
  email: string;
  profilePictureUrl?: string;
  setProfilePictureUrl: React.Dispatch<string>;
  signOut: (data?: Record<string | number | symbol, any> | undefined) => void;
};

const Profile: React.FC<ProfileProps> = ({
  name,
  email,
  profilePictureUrl,
  setProfilePictureUrl,
  signOut,
}) => {
  const [isUploading, setIsUploading] = useState(false);

  const illustrationCallback = async (file: string | ArrayBuffer | null) => {
    setIsUploading(true);
    try {
      const newUrl = await addImageAndGetUrl(file as string);
      setProfilePictureUrl(newUrl);
      // setTimeout(() => setProfilePictureUrl(newUrl), config.imageTemporisation);
    } finally {
      setIsUploading(false);
    }
  };

  const illustrationError = () => {
    setIsUploading(false);
  };

  const uploadIllustration = (file: File) => {
    uploadJPG(file, illustrationCallback, illustrationError);
  };

  return (
    <>
      <Typography variant="h2">Rédacteur Kayter</Typography>
      <Stack direction="row" spacing={1} sx={{ my: 5 }}>
        {isUploading ? (
          <CircularProgress />
        ) : (
          <Button component="label">
            <Avatar src={profilePictureUrl} />
            <FileUpload />
            <input
              type="file"
              hidden
              onChange={({ target }) => {
                const { files } = target;
                if (files) {
                  uploadIllustration(files[0]);
                }
              }}
            />
          </Button>
        )}
        {name && <Typography variant="h5">{name}</Typography>}
      </Stack>
      <Typography variant="h5" sx={{ my: 5 }}>
        {email}
      </Typography>
      <Button variant="outlined" onClick={signOut}>
        Se déconnecter
      </Button>
    </>
  );
};

export default Profile;
